import { configureStore } from "@reduxjs/toolkit";
import colorReducer from "./B2bslice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // ✅ fixed here

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, colorReducer);

const store = configureStore({
  reducer: {
    colorGame: persistedReducer,
  },
});

const persistor = persistStore(store);

// ✅ Export both separately
export { store, persistor };
